module.exports = __webpack_public_path__ + "static/media/21ECLAC20.c10b1477.jpg";